import { DownArrowIcon } from "@xola/icons";
import { Badge, Tooltip } from "@xola/ui-kit";
import clsx from "clsx";
import { isString } from "lodash";
import React, { ReactElement, ReactNode, useEffect, useRef, useState } from "react";
import { LocalizationProps } from "../../../models/Locale";

interface FilterMenuButtonProps extends LocalizationProps {
    text?: ReactNode | string;
    icon?: ReactElement;
    className?: string;
    isDropdown: boolean;
    showTooltipWithFullText?: boolean;
    selectedCount?: number | string;
    onClick?: () => void;
}

export const FilterMenuButton = ({
    text,
    icon,
    className,
    isDropdown = false,
    localize = true,
    showTooltipWithFullText = false,
    onClick,
    selectedCount,
    ...rest
}: FilterMenuButtonProps) => {
    const textRef = useRef<HTMLDivElement>(null);
    const [showTooltip, setShowTooltip] = useState<boolean>(false);
    const textArray = isString(text) ? text?.split(", ") : [];

    useEffect(() => {
        if (!textRef.current) return;

        const isOverflowing = textRef.current.scrollWidth > textRef.current.clientWidth;
        setShowTooltip(showTooltipWithFullText && isOverflowing);
    }, [showTooltipWithFullText, text]);

    return (
        <Tooltip
            content={
                <div className="flex flex-col">
                    {textArray?.map((text) => (
                        <span key={text}>{text}</span>
                    ))}
                </div>
            }
            disabled={!showTooltip}
        >
            <button
                type="button"
                className={clsx(
                    // TODO: UI Kit: We need to define min & max width spacing scheme 144px = w-36
                    "ui-filter-menu-button",
                    "inline-flex min-w-[144px] max-w-xs cursor-pointer justify-between rounded border border-gray-light p-3 text-base leading-base hover:bg-gray-lighter",
                    className,
                )}
                onClick={onClick}
                {...rest}
            >
                <div className="inline-flex w-10/12 space-x-1">
                    <span className="relative top-[-2px]">{icon ? icon : null}</span>
                    <div ref={textRef} className={clsx("truncate whitespace-nowrap", { "no-translate": !localize })}>
                        {selectedCount ? <Badge className="mr-1">{selectedCount}</Badge> : null}
                        {text}
                    </div>
                </div>

                <span>{isDropdown ? <DownArrowIcon /> : null}</span>
            </button>
        </Tooltip>
    );
};
